/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { FILE_HISTORY_REQUEST, success, failure } from './action';

const events = (action$, state$, { AjaxRequest }) =>
  action$
    .ofType(FILE_HISTORY_REQUEST)
    .map(({ payload }) => payload)
    .mergeMap((data) =>
      AjaxRequest.open(
        'post',
        `/admin/filehistory/list`,
        data,
      )('tudo')
        .flatMap(({ response }) => Observable.of(success(response.resource)))
        .catch((err) => Observable.of(failure(err))),
    );

export default combineEpics(events);
